const KEY = 'payment_tracking_flow'
export const sessionStorageAdapter =({
    set(value) {
        sessionStorage.setItem(KEY, value)
    },
    get() {
         return sessionStorage.getItem(KEY)
    },
    remove() {
        sessionStorage.removeItem(KEY)
    }
})